import React, { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import "./Integrations.css";
import styles from "./ProductCard.module.css";
import { integrations } from "./IntegrationData";
import { AuthorizationCard } from "../../../CommonComponents/AuthorizationCard";
import useLocalStorageState from "use-local-storage-state";
import { Button } from "react-bootstrap";
import nodata from "../../../Utils/assets/img/nodata.png";

export const Integrations = () => {
  const [customer] = useLocalStorageState("customer");

  // rbac permission object
  const [PERMISSION, _] = useLocalStorageState('permission');

  // integration permissions
  const integrationGrant = PERMISSION.setting.feature.integration;

  const [searchBarValue, setSearchBarValue] = useState("");


  return (
    <div className="container mb-5 integrations-page">
      <div className="mb-3 d-flex justify-content-between align-items-end">
        {" "}
        <div style={{ lineHeight: "0.8rem" }}>
          <h6
            style={{ fontWeight: "500", color: "black", fontSize: "1.0rem" }}
          >
            Application Integrations
          </h6>
          <p className="text-muted mb-0 small" style={{ color: "#c7c7c7" }}>
            Connect messaging, email, calling and lead-generation services to
            your CRM.{" "}
          </p>
        </div>
        <div
          className="d-flex align-items-center gap-1"
          style={{ height: "39px" }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{ fontSize: "12px", paddingLeft: "36px", height: "35px" }}
              className="form-control "
              value={searchBarValue}
              onChange={(e) => {
                setSearchBarValue(e.target.value);
              }}
            />
            <i
              className="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
          </div>
        </div>
      </div>

      <hr
        className="mt-2 mb-4"
        style={{
          borderTop: "0.5px solid #6c757d",
          opacity: "0.3",
        }}
      />

      {!integrationGrant.isView ?
        <AuthorizationCard /> :
        (
          <div
            className="row gx-3 gy-3 justify-content-start "
            style={{
              scrollbarColor: " #aaafb3 #f3f3f3",
              scrollbarWidth: "thin",
              height: "75vh",
              overflow: "scroll",
            }}
          >
            {(() => {
              const filteredData = integrations.filter((app) => {
                if (!searchBarValue) return true;
                const searchTerm = searchBarValue.toLowerCase();
                return (
                  app.name.toLocaleLowerCase().includes(searchTerm) ||
                  app.category.toLowerCase().includes(searchTerm)
                );
              });

              return filteredData.length === 0 ? (
                <div className="w-100 text-center mt-4">
                  <img
                    src={nodata}
                    alt=""
                    style={{ width: "68vh", marginTop: "10%" }}
                  />
                </div>
              ) : (
                filteredData.map((app, index) => (
                  <div
                    className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex"
                    key={index}
                  >
                    <Link
                      to={app.path}
                      className="text-decoration-none text-dark w-100 d-flex flex-column"
                    >
                      <div
                        className={`integration-card ${styles.product_box} d-flex flex-column h-100`}
                      >
                        <div className="integration-card__icon d-flex justify-content-center align-items-center">
                          <img
                            src={app.logo}
                            alt={app.name}
                            className={`img-fluid integrationImg ${styles.product_box_img}`}
                          />
                        </div>

                        <div className="integration-card__content d-flex flex-column flex-grow-1">
                          <div
                            style={{ lineHeight: "0.9rem", marginBottom: "3px" }}
                          >
                            <h2 className="integration-card__title">
                              {app.name}
                            </h2>
                            <p className={styles.subhead2}>{app.category}</p>
                          </div>

                          <p
                            className="integration-card__description flex-grow-1"
                          >
                            {app.description}
                          </p>
                          <div className="integration-card__footer">
                            <Button
                              className="btnStyleIntegration"
                            >
                              INSTALL
                            </Button>
                            <p className={styles.main_p}>Free</p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              );
            })()}
          </div>
        )
      }
    </div>
  );
};